import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { mobileBottomNavConfig } from '../../config/menuConfig';
import './BottomNavBar.css';

const BottomNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="bottom-nav-bar">
      {mobileBottomNavConfig.map(item => {
        const IconComponent = item.icon;
        const active = isActive(item.path);
        
        return (
          <div
            key={item.key}
            className={`nav-item ${active ? 'active' : ''}`}
            onClick={() => handleNavClick(item.path)}
          >
            <div className="nav-icon">
              <IconComponent />
            </div>
            <div className="nav-title">{item.title}</div>
          </div>
        );
      })}
    </div>
  );
};

export default BottomNavBar;